export default "__VITE_ASSET__BZxb9uIN__"